angular.module('app').directive('cropperImage', ['cropperService', '$timeout', '$q', 'Utils', function (cropperService, $timeout, $q, Utils) {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            model: '=',
            state: '=',
            parentStateName: "=",
            imageTypes: "=",
            required: "="
        },
        templateUrl: "views/cropperImage/main.html",
        link: function ($scope) {
            cropperService.call($scope);
            $scope.calledCount = 0;
            $scope.initialImage = $scope.model.image;


            /**
             * Delete  icon callback
             */
            $scope.deleteImage = function deleteImage() {
                $scope.model.image = false;
                $scope.requiredError = true;
                $scope.draggedImageDataUrl = $scope.draggedImage = $scope.cropped = undefined;
            };


            /**
             * Update image after save
             */
            $scope.model.update = function update() {
                $scope.calledCount = 0;
                $scope.requiredError = false;
                $scope.draggedImageDataUrl = $scope.draggedImage = $scope.cropped = undefined;
                $scope.initialImage = $scope.model.image;
                if ($scope.model.image) {
                    Utils.getBlob($scope.model.image, $scope.load);
                }
            };

            $scope.model.isChanged = function isChanged() {
                var promiseHandler = $q.defer();
                $scope.model.buildResult(function (result) {
                    promiseHandler.resolve(!!result);
                });
                return promiseHandler.promise;
            };


            /**
             * Build result
             */
            $scope.model.buildResult = function buildResult(callback) {
                var result = {};
                $scope.preview(function (dataUrl) {
                    $timeout(function () {
                        $scope.requiredError = false;
                        if (dataUrl && dataUrl.indexOf('data:image') > -1 && ($scope.cropped || $scope.calledCount > 1 || ($scope.draggedImage && $scope.draggedImage.lastModified))) {
                            result.image =  dataUrl;
                            if ($scope.imageTypes && $scope.imageTypes === '.ico,.png') {
                                result.image = result.image.replace("png", "x-icon");
                            }

                        }else if($scope.draggedImageDataUrl === undefined) {
                            if($scope.initialImage) {
                                result.image = false;
                            }
                            if($scope.required) {
                                result.requiredError = true;
                                $scope.requiredError = true;
                            }
                        }

                        if ( Object.keys(result).length > 0){
                            callback && callback(result);
                        } else {
                            callback();
                        }
                    }, 50);

                })
            };

            $scope.isInitialized = true;
        }
    }
}]);
